const randomiseArr = (arr: any[]): any[] => {
  const newArr = arr.sort((a, b) => {
    return 0.5 - Math.random()
  })
  return newArr
}
export default randomiseArr
